import { NgHybridStateDeclaration } from '@uirouter/angular-hybrid';

import { ApiSettingsComponent }      from './api-settings.component';
import { BookingApiSettingsService } from '../bookings/bookings.api-settings.service';
import { CompanyIntegrationsModel }  from '../companies/models/company.integrations';
import { WsApiService }              from '../ws-api/ws-api.service';
import { WsApiSettingsModel }        from '../ws-api/typings/ws-api.settings.model';

export const ApiSettingsStates : Array<NgHybridStateDeclaration> = [
    {
      component: ApiSettingsComponent,
      name     : 'app.api-settings',
      resolve  : [
        {
          deps     : [ BookingApiSettingsService, 'integrations' ],
          resolveFn: ( bookingApiSettingsService : BookingApiSettingsService, integrations : CompanyIntegrationsModel ) : Promise<any> => integrations.has_public_booking_api
            ? bookingApiSettingsService.get()
            : Promise.resolve({}),
          token: 'bookingsApiSettings'
        },
        {
          deps     : [ WsApiService ],
          resolveFn: ( wsApiService : WsApiService ) : Promise<CompanyIntegrationsModel> => wsApiService.getIntegrations(),
          token    : 'integrations'
        },
        {
          deps     : [ 'integrations', WsApiService ],
          resolveFn: ( integrations : CompanyIntegrationsModel, wsApiService : WsApiService, ) : Promise<WsApiSettingsModel> => integrations.has_workshop_api
            ? wsApiService.getSettings()
            : Promise.resolve({} as WsApiSettingsModel),
          token: 'wsApiSettings'
        }
      ],
      url: '/api-settings'
    }
];

